import React from "react";
import { OutletUsersNotDeletedUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const fullName = o => `${o.firstName} ${o.lastName}`;
const mapOutletUser = o => ({ key: o.id, name: fullName(o) });
const sortByFullName = (a, b) => fullName(a).toLowerCase().localeCompare(fullName(b).toLowerCase());

const OutletUsersDropdown = ({
  resources,
  outletUser,
  outletUsers,
  onOutletUserChange,
  onRequestStart,
  onRequestEnd,
  filter,
  containerClass,
  helperText = null,
  inputName = "outletUser",
  id = "outlet-users-dropdown",
  disabled = false,
  required = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["OutletUser"]}
      value={outletUser}
      placeholder={resources["DefaultDropdownValue"]}
      values={outletUsers}
      handleChange={onOutletUserChange}
      inputName={inputName}
      addMarginBottom={false}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={OutletUsersNotDeletedUrl()}
      map={mapOutletUser}
      filter={filter}
      sort={sortByFullName}
    />
  );
};

export default OutletUsersDropdown;
